import { type FC, type ReactNode } from "react";
import { HeaderActions } from "./HeaderActions";

export type TableLayoutProps = {
	userMenu?: ReactNode;
	headerActionButtons?: ReactNode;
	children?: ReactNode;
	title?: ReactNode;
	topContent?: ReactNode;
	scrollable?: boolean;
};

export const TableLayout: FC<TableLayoutProps> = ({
	userMenu,
	headerActionButtons,
	children,
	title,
	topContent,
	scrollable,
}) => {
	const stickyHeaderClasses = scrollable
		? " bg-white sticky top-0 z-50 px-2 border-b border-gray-300"
		: "";
	return (
		<div
			className={`w-full h-full flex flex-col px-[30px]${scrollable ? " overflow-y-auto relative" : ""}`}
		>
			{topContent ? (
				<>
					<div className="w-full min-w-fit pt-[18px] pb-[16px] flex items-center space-x-[20px]">
						<div className="flex-1" />
						{userMenu && <HeaderActions userMenu={userMenu} actionButtons={headerActionButtons} />}
					</div>
					<div className="w-full min-w-fit pb-[18px]">{topContent}</div>
					{title && (
						<div
							className={`w-full min-w-fit pb-[22px] text-gray-700 font-semibold text-[17px]${stickyHeaderClasses}`}
						>
							{title}
						</div>
					)}
				</>
			) : (
				<div
					className={`w-full min-w-fit pt-[18px] pb-[22px] flex items-center space-x-[20px]${stickyHeaderClasses}`}
				>
					<div className="flex-1 text-gray-700 font-semibold text-[17px]">{title}</div>
					{userMenu && <HeaderActions userMenu={userMenu} actionButtons={headerActionButtons} />}
				</div>
			)}
			<div className="w-full flex-1 pb-[15px]">{children}</div>
		</div>
	);
};
